import { List, Create, Edit, View, MyPreSanction, Copy } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/my-pre-sanction",
        component: MyPreSanction,
        name: "fd.voucher.my.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/pre-sanction",
        component: List,
        name: "fd.voucher.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/pre-sanction/create",
        component: Create,
        name: "fd.voucher.pre-sanction.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/pre-sanction/:id/edit",
        component: Edit,
        name: "fd.voucher.pre-sanction.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/pre-sanction/:id/view",
        component: View,
        name: "fd.voucher.pre-sanction.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/pre-sanction/:id/copy",
        component: Copy,
        name: "fd.voucher.pre-sanction.copy",
        meta: {
            requiresAuth: true,
        },
    },
];
